import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Color } from '../../../../assets/color';
import { useNavigate } from 'react-router-dom';

import { SelectSvg } from '../../../../assets/svg';
import { IndianRupee } from '../../../../utils/common-function';
import { downloadPDF } from '../../../../utils/api-function';

import RouteHeader from '../../../../components/common/RouteHeader';
import DatatableHeading from '../../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../../components/datatable/DatatableWithSearch';
import * as SuperadminActions from '../../../../redux/actions/superadminAction';

const GeneratedReport = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { generatedReportsData } = useSelector(state => state?.superadminReducer);

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: (row, index) => index + 1, width: '70px', sortable: false },
        {
            name: 'Date & Time',
            selector: row => row?.createdAt ? new Date(row.createdAt).toLocaleString('en-IN', {
                day: '2-digit', month: 'short', year: 'numeric',
                hour: '2-digit', minute: '2-digit', hour12: true
            }) : '—',
            width: '180px',
            sortable: true,
            sortFunction: (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt),
        },
        { name: 'Admin', selector: row => row?.admin_name || '—', width: '140px', sortable: true },
        { name: 'Partner Name', selector: row => row?.partner_name || '—', width: '160px', sortable: true },
        { name: 'Partner ID', selector: row => row?.partner_registration_number || '—', width: '140px', sortable: true },
        { name: 'Affiliate', selector: row => row?.affiliate_name || '—', width: '160px', sortable: true },
        { name: 'Customer Name', selector: row => row?.full_name || '—', width: '180px', sortable: true },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '—', width: '140px' },
        { name: 'Email', selector: row => row?.email || '—', width: '230px' },
        { name: 'City', selector: row => `${row?.city || ''}${row?.country ? ', ' + row.country : ''}`, width: '160px' },
        { name: 'Age Group', selector: row => row?.age_group || (row?.age ? `${row.age} yrs` : '—'), width: '120px' },
        { name: 'Gender', selector: row => row?.gender || '—', width: '100px' },
        { name: 'Report Type', selector: row => row?.report_type || '—', width: '200px' },
        { name: 'Set', selector: row => row?.report_set?.join(', ') || '—', width: '250px' },
        { name: 'Counselling', selector: row => row?.counselling_included ? 'Included' : 'No', width: '120px' },
        { name: 'Report Amt', selector: row => IndianRupee(row?.report_amount), width: '120px' },
        { name: 'Couns.Amt', selector: row => IndianRupee(row?.counselling_amount), width: '120px' },
        { name: 'Coupon', selector: row => <div style={{ textTransform: 'capitalize' }}>{row?.coupon_code || '—'}</div>, width: '130px' },
        { name: 'Discount %', selector: row => row?.discount_percentage ? `${row.discount_percentage}%` : '—', width: '110px' },
        { name: 'Final Amount', selector: row => IndianRupee(row?.amount), width: '130px' },
        { name: 'Payment', selector: row => row?.payment_method || '—', width: '130px' },
        {
            name: 'Status',
            cell: row => (
                <span style={{
                    padding: '4px 10px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '600',
                    backgroundColor: row?.payment_status === 'Paid' ? '#e6f4ea' : row?.payment_status === 'Pending' ? '#fff8e1' : '#fce8e6',
                    color: row?.payment_status === 'Paid' ? '#1e7e34' : row?.payment_status === 'Pending' ? '#f57f17' : '#c62828',
                }}>
                    {row?.payment_status || '...'}
                </span>
            ),
            width: '120px',
        },
        {
            name: 'Download',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div title="Download & View Report" onClick={() => downloadPDF(`api/report/get-reports`, {
                        report_title: row?.report_type, partner_registration_number: row?.partner_registration_number,
                        scores: row?.report_set || [],
                        customer: {
                            name: row?.full_name || '',
                            father: row?.father_or_husband_name || '',
                            email: row?.email || '',
                            age: row?.age || row?.age_group || '',
                            contact: row?.mobile_number || '',
                            address: `${row?.city || ''} ${row?.country || ''}` || ''
                        }
                    })} style={{ cursor: "pointer" }}>
                        <SelectSvg />
                    </div>
                </div>
            ),
            right: 'true',
            width: '100px',
        },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(SuperadminActions.getGeneratedReports());
    }, []);

    return (
        <>
            <RouteHeader title="Generated Reports" sub_title="View customers who have generated reports" />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title="Generated Reports List" sub_title={`Total ${generatedReportsData?.length || 0} reports. This section shows the list of customers who have generated reports.`} />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={generatedReportsData} columns={columns} pagination={true} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default GeneratedReport;
